module.exports = __webpack_public_path__ + "static/media/project_web.af507865.jpg";